.svg {
  display: inline-block;
  transition: fill var(--dds-motion-micro-state);
  flex-shrink: 0;
}
